import React from 'react';
const Comment3 = (props) => {
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("circle", { cx: "7.875", cy: "7.875", r: "7.875", transform: "matrix(1 0 0 -1 1.125 16.875)", fill: "#4C6AFF" }),
        React.createElement("path", { d: "M9 12.7125V7.87504", stroke: "white", "stroke-width": "1.125", "stroke-linecap": "round" }),
        React.createElement("path", { d: "M9.67422 5.5125C9.67422 5.13971 9.37201 4.8375 8.99922 4.8375C8.62643 4.8375 8.32422 5.13971 8.32422 5.5125C8.32422 5.88529 8.62643 6.1875 8.99922 6.1875C9.37201 6.1875 9.67422 5.88529 9.67422 5.5125Z", fill: "white" })));
};
export default Comment3;
